import { createBaseService } from '~/services/base.axios.service.js'
import { getRequestHeaders } from '~/services/request.headers.js'

const service = createBaseService(getRequestHeaders)

export default service
